import { Text, View } from "@react-pdf/renderer";

const Answer = ({ answer, styles }) => {
  return (
    <View styles={{ marginTop: "3px" }}>
      <Text style={{ ...styles.para }}>
        {answer?.answer?.answer || "--"}
      </Text>
    </View>
  )
}

export default Answer;